export default __webpack_public_path__ + "static/media/vans-W.35933633.png";